import { twMerge } from '@/lib/classname/twMerge'
import { cva, type VariantProps } from 'class-variance-authority'

export const containerSizes = ['sm', 'md', 'lg'] as const

const innerContainerVariants = cva('mx-auto', {
  variants: {
    size: {
      sm: 'max-w-lg',
      md: 'max-w-5xl',
      lg: 'desktop-lg:max-w-[1376px]',
    },
  },
  defaultVariants: {
    size: 'lg',
  },
})

export type ContainerProps = React.PropsWithChildren<
  VariantProps<typeof innerContainerVariants> & {
    id?: string
    className?: string
    noPadding?: boolean
  }
>

/**
 * Wraps content in responsive container with optional size variants.
 * Content needs to be full width to work properly.
 * Not suitable for use within other containers or in columns.
 */
export function Container({
  id,
  children,
  className,
  size,
  noPadding,
}: ContainerProps): React.ReactElement {
  return (
    <div
      data-type="container"
      id={id}
      className={twMerge(className, 'w-full', !noPadding && 'px-2 desktop:px-4')}
    >
      <div className={innerContainerVariants({ size })}>{children}</div>
    </div>
  )
}
